// Generated by CoffeeScript 2.7.0
var EditCascadedSelectOptionsModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

export default EditCascadedSelectOptionsModal = Vue.extend({
  components: {
    'modal': Modal
  },
  props: {
    title: {
      type: String,
      default: '批量新增下级'
    },
    cascadedSelectId: {
      type: Number
    },
    parentId: {
      type: Number,
      default: null
    },
    callback: {
      type: Function
    }
  },
  data: function() {
    return {
      valid: true,
      choices: ''
    };
  },
  template: `<modal :title="title"
       extendClass="cascaded-select-modal"
       @ensureClicked="ensureClickedFunc"
       @cancelClicked="cancelClickedFunc"
       size='small'
       ref="cascadedSelectModalRef">
  <template>
    <div class="modal-body mt-5">
      <div class="form-field required"
           :class="{ 'has-error': !valid }">
        <div class="form-field-head mr-2">
          <div class="form-field-title">选项内容</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <textarea class="form-field-value"
                      placeholder="请输入"
                      type="text"
                      v-model.trim="choices">
            </textarea>
          </div>
          <div class="message">不能为空</div>
        </div>
      </div>
    </div>
  </template>
</modal>`,
  methods: {
    getData: function() {
      return {
        cascaded_select_id: this.cascadedSelectId,
        choices: _.map(this.choices.split('\n'), (option) => {
          return {
            name: option,
            parent_id: this.parentId
          };
        }),
        parent_id: this.parentId
      };
    },
    ensureClickedFunc: function() {
      this._validate();
      if (!this.valid) {
        this.$refs.cascadedSelectModalRef.open();
        return;
      }
      return this.doRequest();
    },
    doRequest: function() {
      return Skylark.Libs.Ajax.post("/admin/choices/create_collection", {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: this.getData(),
        success: (res) => {
          Skylark.Bridge.newAlertify('新增成功', {
            type: 'success'
          });
          return this.callback(res);
        },
        error: function() {
          return Skylark.Bridge.newAlertify('新增失败', {
            type: 'error'
          });
        }
      });
    },
    cancelClickedFunc: function() {
      return this.choices = '';
    },
    _validate: function() {
      return this.valid = Boolean(this.choices);
    }
  }
});
